<template>
  <router-link v-if="user" :to="{ name: 'profile' }" class="link">
    <div class="logged-user">
      <font-awesome-icon :icon="['far', 'building']" class="entity-icon"/>
      <span class="text-line-1" id="user_company_title" :title="user.companyTitle">{{ user.companyTitle }}</span>
      <font-awesome-icon :icon="['fa', 'user']" class="entity-icon"/>
      <span class="text-line-1" id="user_full_name" :title="user.fullName">{{ user.fullName }}</span>
    </div>
  </router-link>
</template>

<script>
import IconInCircle from '@/components/ui/IconInCircle.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    IconInCircle
  },
  computed: {
    ...mapGetters('session', ['user', 'info'])
  }
}
</script>

<style lang="scss" scoped>
.logged-user {
  display: grid;
  grid-template-columns: 15px auto;
  grid-column-gap: .25rem;
  grid-row-gap: .75rem;
  font-size: 0.85rem;
  cursor: pointer;
  padding: .75rem .5rem .75rem 1rem;
  color: #BCCCDC;
  border-color: #486581;
  border-top-style: solid;
  border-top-width: 1px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  &:hover {
    background-color: #486581;
  }
}
</style>
